import { getLink } from '@/api/link';
import Pagination from '@/components/Pagination2';
import SelectBox from '@/components/SelectBox';
import StarProgress from '@/components/StarProgress';
import { INTERFACE } from '@/utils/INTERFACE';
import { formatPrice, getCurrency } from '@/utils/currency';
import http from '@/utils/http';
import { getSite } from '@/utils/site';
import { getArriveId } from '@/utils/siteDefs';
import translate from '@/utils/translate';
import { getParams } from '@/utils/urlQuery';
import $ from 'jquery';
import _ from 'lodash';
import querystring from 'querystring';
import Vue from 'vue';
import manager from '../manager';
import { activeModules } from '@/view/lib/lazy'
import {getSystem} from '@/utils/site'


// const mockData = JSON.parse(JSON.stringify(Array(8).fill(
// 	{
// 		img: "//img13.joybuy.com/n1/s220x220_jfs/t5578/160/1306148691/81527/d63e613e/592551acNbc53419d.jpg",
// 		name: "清华开发者书库 数字信号处理：原理、实现及应用（基于MATLAB/Simulink与TMS320C55xx DSP的实现",
// 		price: formatPrice(10.45),
// 		current: 0
// 	}
// )))


var ResultCache=null

manager.add('shopCommodity', {
	created(defaultSort, defaultMaxLen) {
		defaultSort = parseInt(defaultSort) || 0
		defaultMaxLen = parseInt(defaultMaxLen) || 60
		this.instance = new Vue({
			el: this.dom,
			components: {
				StarProgress: StarProgress,
				Pagination: Pagination,
			},
			data() {
				var params = getParams()
				return {
					list: [],
					recommend: [],
					recomendCurrent: 0,
					search: {
						sort: params.sort || defaultSort,
						minPrice: params.minPrice ? parseFloat(params.minPrice) : null,
						maxPrice: params.maxPrice ? parseFloat(params.maxPrice) : null,
						isStar: params.isStar == 'true',
						isCollection: params.isCollection == 'true',
						showType: params.showType || "grid",
						keyword: params.keyword || "",
						pageNo: params.pageNo || 1,
						shopCategoryId: params.shopCategoryId,
						filtBy618: params.filtBy618 == 'true'
					},
					pageCount: 1,
					totalCount: null,
					loading: false
				}
			},
			computed: {
				recommendSlideLen() {
					return (this.recommend.length > 5 ? Math.ceil((this.recommend.length - 5) / 5) : 0) + 1
				},
				recommendSlideCurrent() {
					return Math.round(this.recomendCurrent / 5)
				}
			},
			mounted() {
				this.onSearch()
			},
			methods: {
				getLink: getLink,
				translate: translate,
				getSildeIndex(i, total, back, slice = 4) {
					return back ? (i - slice >= 0 ? (i - slice) : 0) : (i + slice <= total ? (i + slice) : total)
				},
				setShowType(str) {
					this.search.showType = str
				},
				setSearchParam(key, value, norefresh) {
					if (key == 'pageNo') {
						location.hash = "module-top"
					} else {
						this.search.pageNo = 1
					}
					this.search[key] = value
					if (!norefresh) {
						this.onSearch()
					}
					//替换链接参数
					var str = querystring.stringify(_.pickBy({
						...getParams(),
						...this.search,
						pageNo:null
					}, _.identity))
					var urlpath = `${location.pathname}?${str}`
					if (!window.history.replaceState) {
						if (!norefresh) {
							location.search = str
						}
						return
					}
					window.history.replaceState(null, null, urlpath)
				},
				async onSearch() {
					this.loading = true
					var extstr = getParams().ext
					if (extstr == '{}') {
						extstr = null
					}
					var res = await http.jsonp.get(INTERFACE().shopSearch, _.pickBy({
						venderId: $("#J_venderId").val(),
						siteFlag: getSite().toLowerCase(),
						pageSize: defaultMaxLen,
						orderBy: this.search.sort,
						filtByCommentStar: this.search.isStar ? 1 : null,
						filtBy618: this.search.filtBy618 ? 1 : null,
						arriveId: getArriveId(),
						currency: getCurrency(),
						filters: extstr,
						..._.pick(this.search, ['minPrice', 'maxPrice', 'shopCategoryId', 'keyword', 'pageNo'])
					}, _.identity))
					var list = (res.productResult.list || []).map(it => {
						it.subProductList=it.subProductList||[]
						return {
							img: INTERFACE().image(it.imageurl),
							price: formatPrice(parseFloat(it.lowpPrice), parseFloat(it.highPrice)),
							name: it.warename,
							good: it.good,
							wareid: (getSystem()=='th'&&!res.productResult.bestSell)?null:it.wareid,
							star: it.commentStar ? parseFloat(it.commentStar) * 20 : 0,
							commentNum: it.commentcount || 0,
							subListIdsStr: it.subProductList.map(sub => sub.wareid).join(","),
							subList: it.subProductList.map(sub => ({
								img: INTERFACE().image(sub.imageurl),
								wareid: sub.wareid,
								name: sub.name,
							})),
							leftIcon: it.icons && it.icons.Operation ? INTERFACE().image0(it.icons.Operation) : null,
							rightIcon: it.icons && it.icons['618'] ? INTERFACE().image0(it.icons['618']) : null,
							subCurrent: 0,
							subListSlideLen: it.subProductList.length - 4,
							current: getSystem()=='th'?0:null,
							useStar:getSystem()!='th'
						}
					})
					if (res.productResult.bestSell) {
						this.recommend = list
						this.list = []
					} else {
						this.recommend = []
						this.list = list
					}
					this.pageCount = res.productResult.pageCount
					this.totalCount = res.productResult.totalCount
					this.loading = false
					ResultCache={
						result: res,
						search: this.search
					}
					$(window).trigger('ShopCommodity.result', ResultCache)
					this.$nextTick(() => activeModules(this.$refs.item || []))
				}
			}
		})
	},
	destroyed() {
		if (this.instance) {
			this.instance.$destroy()
		}
	}
})


manager.add('shopCommodity.collapse', function (i) {
	var arrow = $(this.dom).find(".classify-arrow")
	var child = $(this.dom).find("ul")
	if (i == 0) {
		arrow.removeClass("d-icon-down").addClass("d-icon-up")
	} else {
		child.hide()
	}
	arrow.on("click", () => {
		if (arrow.hasClass("d-icon-down")) {
			arrow.removeClass("d-icon-down").addClass("d-icon-up")
		} else {
			arrow.removeClass("d-icon-up").addClass("d-icon-down")
		}
		child.slideToggle()
	})
})

var extCache = null
manager.add('shopCommodity.extSearch', {
	created() {
		this.instance = new Vue({
			el: this.dom,
			components: {
				SelectBox: SelectBox
			},
			data() {
				return {
					list: extCache || [],
					searched: {},
					more: false,
				}
			},
			computed: {
				searchedList() {
					var arr = []
					var { list, searched } = this
					for (let i in list) {
						let parent = {
							...list[i],
							child: []
						}
						if (!searched[list[i].id]) {
							continue
						}
						for (let j in list[i].child) {
							let childItem = list[i].child[j]
							if (!searched[list[i].id].includes(childItem.id)) {
								continue
							}
							parent.child.push(childItem)
						}
						arr.push(parent)
					}
					return arr
				},
				sliceList() {
					if (this.more) {
						return this.list
					}
					return this.list.slice(0, 6)
				}
			},
			mounted() {
				this.fetchExtInfo()
				if(ResultCache){
					this.onResult(null,ResultCache)
				}
				$(window).on("ShopCommodity.result", this.onResult)
			},
			destroyed() {
				$(window).off("ShopCommodity.result", this.onResult)
			},
			methods: {
				fetchExtInfo() {
					var ext = {}
					var extstr = getParams().ext
					if (!extstr) {
						return
					}
					try {
						ext = JSON.parse(extstr)
					} catch (err) {
						//
					}
					this.searched = ext
				},
				formatPrice,
				onSelect(pid, ids) {
					var str = querystring.stringify(_.pickBy({
						...getParams(),
						ext: JSON.stringify({
							...this.searched,
							[pid]: _.uniq([
								...(this.searched[pid] || []),
								...ids
							])
						})
					}, _.identity))
					location.search = str
				},
				removeExt(pid) {
					var str = querystring.stringify(_.pickBy({
						...getParams(),
						ext: JSON.stringify({
							...this.searched,
							[pid]: undefined
						})
					}, _.identity))
					location.search = str
				},
				getExtLink(pid, id) {
					var str = querystring.stringify(_.pickBy({
						...getParams(),
						ext: JSON.stringify({
							...this.searched,
							[pid]: _.uniq([
								...(this.searched[pid] || []),
								id
							])
						})
					}, _.identity))
					return `${location.pathname}?${str}`
				},
				getExtClearLink() {
					var str = querystring.stringify(_.pickBy({
						...getParams(),
						ext: null
					}, _.identity))
					return `${location.pathname}?${str}`
				},
				getPriceLink(min, max) {
					var str = querystring.stringify(_.pickBy({
						...getParams(),
						minPrice: min,
						maxPrice: max
					}, _.identity))
					return `${location.pathname}?${str}`
				},
				onResult(e, data) {
					var res = data.result.productResult
					var ext = res.extAttrCate || []
					var list = []
					for (let k in ext) {
						let [id, title] = k.split('-')
						let child = []
						for (let j in ext[k]) {
							let [id, title] = ext[k][j].split('-')
							child.push({
								id,
								title: decodeURIComponent(title)
							})
						}
						if (child.length) {
							list.push({
								id,
								title: decodeURIComponent(title),
								showSelect: false,
								child
							})
						}
					}
					this.list = list
					extCache = list
					this.fetchExtInfo()
				}
			}
		})
	},
	destroyed() {
		if (this.instance) {
			this.instance.$destroy()
		}
	}
})